import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {baseUrl} from "../../../../../../../core/constants/base-url";
import {noteFilesResourceParams} from "../configs/note-files-modal-config";
import {Observable} from "rxjs";
import {AttachNoteFileParams, NoteFilesData} from "../types/note-files-modal.types";

@Injectable({
  providedIn: 'root'
})
export class NoteFilesModalApiService {
  private http = inject(HttpClient);
  private url = `${baseUrl}/${noteFilesResourceParams.path}`;

  public getNoteFiles(noteId: number): Observable<Array<NoteFilesData>> {
    return this.http.get<Array<NoteFilesData>>(`${this.url}`, { params: { noteId: noteId } });
  }

  public attachNoteFile(attachNoteFileParams: AttachNoteFileParams): Observable<NoteFilesData> {
    return this.http.post<NoteFilesData>(`${this.url}`, attachNoteFileParams);
  }

  public deleteNoteFile(id: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }
}
